var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.0054 9.35497V9.99945C17.0045 11.5101 16.5153 12.9799 15.6108 14.1898C14.7064 15.3998 13.435 16.2849 11.9864 16.7132C10.5377 17.1415 8.98947 17.0901 7.57247 16.5665C6.15546 16.043 4.94564 15.0755 4.12345 13.8082C3.30125 12.541 2.91073 11.0419 3.01012 9.53453C3.10951 8.02718 3.6935 6.59235 4.67498 5.44402C5.65646 4.29569 6.98285 3.49538 8.45633 3.16247C9.92981 2.82956 11.4714 2.98187 12.8513 3.59669",
    stroke: "#0BD78E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.0052 4.39453L10 11.4067L7.89844 9.30518",
    stroke: "#0BD78E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.947c52d7a6931d80f9fc4cd6d6a5d5d2.svg";
export { ForwardRef as ReactComponent };